import { CardContent, Skeleton } from "@qw/ui";
import type { FC } from "react";

export const DraftSkeleton: FC = () => (
  <CardContent className="space-y-4">
    <div className="space-y-2">
      <Skeleton className="h-4 w-1/4" />
      <Skeleton className="h-4 w-3/4" />
    </div>
    <div className="space-y-2">
      <Skeleton className="h-4 w-1/4" />
      <Skeleton className="h-4 w-2/3" />
    </div>
    <div className="space-y-2">
      <Skeleton className="h-4 w-1/4" />
      <Skeleton className="h-4 w-full" />
    </div>
    <div className="space-y-2">
      <Skeleton className="h-32 w-full" />
    </div>
  </CardContent>
);
